export default __webpack_public_path__ + "static/media/q8_step3.79a11fbe.png";